import { render, staticRenderFns } from "./register-polite.vue?vue&type=template&id=096da118&scoped=true&"
import script from "./register-polite.vue?vue&type=script&lang=js&"
export * from "./register-polite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096da118",
  null
  
)

export default component.exports